<div class="row wrapper border-bottom page-heading">
  <div class="col-lg-10">
    <h2>{{type ? 'Programa' : 'Projeto Agregador'}}</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">

        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }} Análise</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Projeção para o ano</label>
                <ng-select id="ind_analysis_stat_id" class="ng-select-alternative" [items]="list?.indStats" bindLabel="label" bindValue="id" placeholder="Selecione a Projeção" formControlName="ind_analysis_stat_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('ind_analysis_stat_id')" [erros]="fieldErros('ind_analysis_stat_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Situação</label>
                <textarea id="description" class="form-control" rows="8" formControlName="description" placeholder="Descrição da Situação" maxlength="1000"></textarea>
                <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>